import { useTheme } from '../core'

/**
 * Use the image sizes breakpoint value
 * @param sizeConfig
 * @returns string
 */
export const useImageSizesProp = (
  sizeConfig:
    | number
    | string
    | [number | string]
    | [number | string, number | string]
    | [number | string, number | string, number | string]
    | {
        _: number | string
        tablet?: number | string
        pc?: number | string
      },
) => {
  const [fallback, tablet, pc] =
    typeof sizeConfig === 'number' || typeof sizeConfig === 'string'
      ? [sizeConfig, undefined, undefined]
      : Array.isArray(sizeConfig)
      ? sizeConfig
      : [sizeConfig._, sizeConfig.tablet, sizeConfig.pc]

  const theme = useTheme()

  const tabletMedia = tablet
    ? `(min-width: ${theme.breakpoints.tablet}) ${tablet},`
    : ''

  const pcMedia = pc ? `(min-width: ${theme.breakpoints.pc}) ${pc},` : ''

  return `${pcMedia}${tabletMedia}${fallback}`
}
